import http from './http';

interface SendRequestMessageData {
  phone: string;
  name: string;
  time: string;
  code?: string;
  email: string;
  corporateName: string;
  companyType: Array<string>;
  place: string;
  capitalStock: string;
}

export function sendConsultantMessage(phone: string) {
  return http.post(
    `${process.env.AILABS_API_BASE_URL}/message/mybuild/consultant`,
    {
      phone: `82${phone.replace(/-/gi, '').substring(1)}`,
    },
  );
}

export function sendRequestMessage(data: any) {
  return http.post(`https://msa.ailabscorp.com/register/request-mybuild`, data);
}
